import styled from "styled-components";

export const ContentContainer = styled.section`
  width: 100%;
  flex: 1;
`;

export const LayoutContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
`;

export const LayoutContent = styled.div`
  position: relative;
  height: 100%;
  flex: 1;
  overflow: hidden auto;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
`;
